import React from 'react';
import { ReturnRow } from '../driverReturnsTypes';
import styles from './ReturnQueueTable.module.css';

interface ReturnQueueTableProps {
  rows: ReturnRow[];
  onProcess?: (id: string) => void;
  onViewDetails?: (id: string) => void;
}

export const ReturnQueueTable: React.FC<ReturnQueueTableProps> = ({
  rows,
  onProcess,
  onViewDetails,
}) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Return Queue</h3>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>RETURN ID</th>
              <th>ORDER #</th>
              <th>CUSTOMER NAME</th>
              <th>REASON</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={styles.bold}>{row.returnId}</td>
                <td>{row.orderId}</td>
                <td>{row.customerName}</td>
                <td>{row.reason}</td>
                <td>
                  <span
                    className={`${styles.status} ${styles[`status_${row.status.replace(/\s+/g, '').toLowerCase()}`]}`}
                  >
                    {row.status}
                  </span>
                </td>
                <td>
                  {row.status === 'Completed' ? (
                    <button
                      className={styles.btnSuccess}
                      onClick={() => onViewDetails?.(row.id)}
                    >
                      View Details
                    </button>
                  ) : (
                    <button
                      className={styles.btnPrimary}
                      onClick={() => onProcess?.(row.id)}
                    >
                      Process Return
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
